import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchManualPreadviceTransactionsCreate = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createManualPreadviceTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    comments: payload.params.comments,
    departureDateTime: payload.params.departureDateTime,
    impcFrom: payload.params.impcFrom,
    impcTo: payload.params.impcTo,
    operatorFrom: payload.params.operatorFrom,
    operatorTo: payload.params.operatorTo,
    plannedArrivalDateTime: payload.params.plannedArrivalDateTime,
    quantity: payload.params.quantity,
  });
};

export default apiFetchManualPreadviceTransactionsCreate;
